import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import { StatusProvider } from "@/context/StatusContext";
import Landing from "@/pages/Landing";
import Moderator from "@/pages/Moderator";
import DecisionPage from "@/pages/DecisionPage";
import DisputePage from "@/pages/DisputePage";
import LegalPage from "@/pages/LegalPage";
import ResultsPage from "@/pages/ResultsPage";
import MyCasesPage from "@/pages/MyCasesPage";
import LiveChatPage from "@/pages/LiveChatPage";
import AvailabilityPage from "@/pages/AvailabilityPage";
import AcademyPage, { AcademyEnter } from "@/pages/AcademyPage";
import AcademyModulePage from "@/pages/AcademyModulePage";
import AcademyVerifyPage from "@/pages/AcademyVerifyPage";
import EventCancelPage from "@/pages/EventCancelPage";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/common/CookieConsent";
import { BanGate } from "@/components/common/BanGate";
import { MandatoryNotice } from "@/components/common/MandatoryNotice";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BanGate>
        <AuthProvider>
          <StatusProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/moderator" element={<Moderator />} />
              <Route path="/decision/:token" element={<DecisionPage />} />
              <Route path="/dispute/:token" element={<DisputePage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/my-cases" element={<MyCasesPage />} />
              <Route path="/live/:token" element={<LiveChatPage />} />
              <Route path="/availability" element={<AvailabilityPage />} />
              <Route path="/academy" element={<AcademyPage />} />
              <Route path="/academy/enter/:token" element={<AcademyEnter />} />
              <Route path="/academy/m/:moduleId" element={<AcademyModulePage />} />
              <Route path="/academy/verify/:code" element={<AcademyVerifyPage />} />
              <Route path="/events/cancel/:token" element={<EventCancelPage />} />
              <Route path="/privacy" element={<LegalPage slug="privacy" />} />
              <Route path="/terms" element={<LegalPage slug="terms" />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <MandatoryNotice />
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
          <CookieConsent />
          </StatusProvider>
        </AuthProvider>
        </BanGate>
      </LangProvider>
    </div>
  );
}

export default App;
